<template>
  <div class="row">
    <div class="col-xs-12 col-md-6">
      <masked-text-box :label="$t('synergrid.config.oldRef')" data-cy="config-form-synergid-old-ref" mask="##.##.##" pattern="[0-9]{2}[.][0-9]{2}[.][0-9]{2}" placeholder="##.##.##" required tel v-model="value.oldRef"></masked-text-box>
    </div>
    <div class="col-xs-12 col-md-6">
      <text-box :label="$t('synergrid.config.oldGroup')" data-cy="config-form-synergid-old-group" required v-model="value.oldGroup"></text-box>
    </div>
    <div class="col-xs-12 col-md-6">
      <masked-text-box :label="$t('synergrid.config.newRef')" data-cy="config-form-synergid-new-ref" mask="##.##.##" pattern="[0-9]{2}[.][0-9]{2}[.][0-9]{2}" placeholder="##.##.##" required tel v-model="value.newRef"></masked-text-box>
    </div>
    <div class="col-xs-12 col-md-6">
      <text-box :label="$t('synergrid.config.newGroup')" data-cy="config-form-synergid-new-group" required v-model="value.newGroup"></text-box>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit, Inject, Watch } from 'vue-property-decorator'
import { idGenerator, helper } from '@/services'
import { ModifyRefRequestInfo } from '@/models'

@Component({
  name: 'synergrid-modify-ref-request-form',
})
export default class SynergridModifyRefRequestForm extends Vue {

  //#region [Property]
  @Prop({ type: Object, required: true })
  public readonly value!: ModifyRefRequestInfo
  //#endregion

  //#region [Data]
  public fieldId: string = idGenerator.getId()
  //#endregion
}
</script>